import React, { Component } from 'react'
import TransitionGroup from 'react-addons-css-transition-group'

import classNames from './KenBurns.css'

const RANDOM_CLASSNAME = [
  classNames.imageTopLeft,
  classNames.imageTopRight,
  classNames.imageBottomLeft,
  classNames.imageBottomRight
]

export default class KenBurns extends Component {
  static defaultProps = {
    options: {
      delay: 3,
      transition: 1
    }
  }
  state = {
    index: null,
    remainingLoops: this.props.repeat
  }
  componentDidMount () {
    this.mounted = true
    const { images, count, loadMoreImages, onFinish } = this.props
    if (images.length === 0) {
      if (count !== 0) {
        loadMoreImages().then(() => this.loadSlide(0, 0))
      } else {
        // No images to show so just finish immediately
        console.warn('Skipping presentation with no images')
        onFinish()
      }
    } else {
      this.loadSlide(0, 0)
    }
  }
  componentWillReceiveProps (nextProps) {
    const { paused } = this.props
    if (paused && !nextProps.paused && this.loadSlideOnPlay) {
      clearTimeout(this.delayTimeout)
      this.loadSlide(this.state.index + 1, 1000)
      this.loadSlideOnPlay = false
    }
  }
  componentWillUnmount () {
    clearTimeout(this.delayTimeout)
    clearTimeout(this.finishTimeout)
    this.mounted = false
  }
  // shouldComponentUpdate (nextProps, nextState) {
  //   const { index } = this.state
  //   if (index !== nextState.index) {
  //     return true
  //   }
  //   return false
  // }
  loadSlide (index, delay) {
    const { options, getImageSource, images, count, loadMoreImages, onChangeSlide, onFinish } = this.props
    const nextImageID = images[index]
    delay = typeof delay !== 'undefined' ? delay : options.delay * 1000

    const delayPromise = new Promise(resolve => {
      this.delayTimeout = setTimeout(resolve, delay)
    })

    const loadPromise = new Promise(resolve => {
      const img = new window.Image()
      img.onload = resolve
      img.onerror = resolve
      img.src = getImageSource(nextImageID, 'p')
    })

    return Promise.all([delayPromise, loadPromise]).then(() => {
      if (!this.mounted) {
        return
      }
      if (this.props.paused && delay !== 0) {
        this.loadSlideOnPlay = true
        return
      }
      if (onChangeSlide) {
        onChangeSlide(index)
      }
      this.setState({
        index,
        imageClassName: RANDOM_CLASSNAME[Math.floor(Math.random() * RANDOM_CLASSNAME.length)]
      })
      const nextIndex = index + 1

      if (images[nextIndex]) {
        this.loadSlide(nextIndex)
      } else {
        if (images.length === count) {
          const { remainingLoops } = this.state
          if (remainingLoops) {
            this.loadSlide(0)
            this.setState({
              remainingLoops: remainingLoops - 1
            })
          } else if (onFinish) {
            this.finishTimeout = setTimeout(() => {
              this.setState({
                index: null
              })
              this.finishTimeout = setTimeout(onFinish, options.transition * 1000)
            }, options.delay * 1000)
          } else {
            this.loadSlide(0) // Loop back around by default
          }
        } else {
          loadMoreImages().then(() => this.loadSlide(nextIndex))
        }
      }
    })
  }
  nextSlide () {
    const { images } = this.props
    const { index } = this.state
    if (index < images.length - 1) {
      clearTimeout(this.delayTimeout)
      this.loadSlide(index + 1, 0)
    }
  }
  prevSlide () {
    const { index } = this.state
    if (index > 0) {
      clearTimeout(this.delayTimeout)
      this.loadSlide(index - 1, 0)
    }
  }
  render () {
    const { images, paused, getImageSource, options } = this.props
    const { index, imageClassName } = this.state
    const id = images[index]
    const transitionName = {
      enter: classNames.enter,
      enterActive: classNames.enterActive,
      leave: classNames.leave,
      leaveActive: classNames.leaveActive
    }
    const imageStyle = {
      backgroundImage: id && `url(${getImageSource(id, 'p')})`,
      animationDuration: `${options.delay + options.transition}s`,
      animationPlayState: paused ? 'paused' : undefined,
      transitionDuration: `${options.transition}s`
    }

    return (
      <TransitionGroup
        transitionName={transitionName}
        transitionEnterTimeout={1000}
        transitionLeaveTimeout={1000}>
          {id &&
            <div key={id} className={imageClassName} style={imageStyle} />
          }
      </TransitionGroup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/present/KenBurns.js